export enum RequestSortKey {
   UserEmail = 'userEmail',
   FullName = 'fullName',
   Domain = 'domain',
   CreatedAt = 'createdAt',
   DueDate = 'dueDate',
   ActionId = 'actionId',
   TicketSource = 'ticketSource',
   TicketState = 'ticketState',
   ClosingReason = 'closingReason',
   Country = 'country',
   Rights = 'privacyRightId',
   GroupIdAssignment = 'groupIdAssignment',
   BrandId = 'brandId',
   StateOfResidence = 'stateOfResidence',
   DataSubjectType = 'dataSubjectType',
   DataSubjectTypeLabel = 'dataSubjectTypeLabel',
   VerifiedAt = 'verifiedAt',
   ExternalTicketId = 'externalTicketId',
   ClosedAt = 'closedAt',
   ClosedBy = 'closedBy',
}
